import RestService from "~/core/services/rest.service";

export class CertificateTagsService extends RestService {
  /**
   * Get a list of certificate tags
   * @return List
   */
  async getTags(): Promise<string[]> {
    return this.$api.get("certificates/tags");
  }
}

export default new CertificateTagsService();
